import { Fabric } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Options from '../../components/Options/Options';
import { setApiKey, showBrandfolders } from '../../actions';
import './GettingStarted.css';

class GettingStarted extends React.Component {
  static propTypes = {
    apiKey: PropTypes.string
  };

  render() {
    return (
      <Fabric>
        <h1>Getting Started</h1>
        <p>
          To get started, copy and paste your{' '}
          <a
            href="https://brandfolder.com/profile#integrations"
            target="_blank"
            rel="noopener noreferrer"
          >
            Brandfolder API key
          </a>{' '}
          below.
        </p>
        <Options apiKey={this.props.apiKey} onSubmit={value => this.props.setApiKey(value)} />
        <p className="no-account">
          Don't have a Brandfolder account?{' '}
          <a href="https://brandfolder.com/home" target="_blank" rel="noopener noreferrer">
            Learn more about Brandfolder here
          </a>.
        </p>
      </Fabric>
    );
  }
}

const mapStateToProps = state => ({
  apiKey: state.brandfolder.apiKey
});

const mapDispatchToProps = dispatch => ({
  setApiKey: apiKey => {
    dispatch(setApiKey(apiKey));
    dispatch(showBrandfolders());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GettingStarted);



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/GettingStarted.js